interface LicensePlateProps {
  licenseNumber?: string | null
  country?: string | null
}

export function NumberPlate({ licenseNumber, country }: LicensePlateProps) {
  if (!licenseNumber) return null
  const eu = country ? (country === 'CH' ? false : true) : false
  return (
    <div className={`plateArea ${eu ? 'eu' : ''}`}>
      <span>{licenseNumber}</span>
      <img src={`/img/kantons/${eu ? 'EU' : licenseNumber.slice(0, 2)}.svg`} width="15" height="17" />
    </div>
  )
}
